import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Home } from "lucide-react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-gradient-starfield flex items-center justify-center relative overflow-hidden">
      {/* Animated Stars */}
      <div className="absolute inset-0">
        {[...Array(50)].map((_, i) => (
          <div
            key={i}
            className="absolute w-1 h-1 bg-gold rounded-full animate-pulse"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 3}s`,
              animationDuration: `${1 + Math.random() * 2}s`,
            }}
          />
        ))}
      </div>

      <div className="text-center relative z-10 max-w-md mx-auto px-4">
        {/* Lotus Icon */}
        <div className="mb-8">
          <svg width="120" height="120" viewBox="0 0 120 120" className="mx-auto text-gold fill-current floating-lotus">
            <path d="M60 20 Q40 40 60 60 Q80 40 60 20" transform="rotate(0 60 60)" />
            <path d="M60 20 Q40 40 60 60 Q80 40 60 20" transform="rotate(45 60 60)" />
            <path d="M60 20 Q40 40 60 60 Q80 40 60 20" transform="rotate(90 60 60)" />
            <path d="M60 20 Q40 40 60 60 Q80 40 60 20" transform="rotate(135 60 60)" />
            <path d="M60 20 Q40 40 60 60 Q80 40 60 20" transform="rotate(180 60 60)" />
            <path d="M60 20 Q40 40 60 60 Q80 40 60 20" transform="rotate(225 60 60)" />
            <path d="M60 20 Q40 40 60 60 Q80 40 60 20" transform="rotate(270 60 60)" />
            <path d="M60 20 Q40 40 60 60 Q80 40 60 20" transform="rotate(315 60 60)" />
            <circle cx="60" cy="60" r="8" className="text-gold-light" fill="currentColor" />
          </svg>
        </div>

        <h1 className="font-serif text-6xl font-bold text-gold text-glow mb-4">404</h1>
        <h2 className="font-serif text-2xl font-bold text-gold-light mb-6">Pagina Niet Gevonden</h2>
        
        <p className="text-gold-light/80 mb-8 leading-relaxed">
          Deze pagina bestaat niet of is verplaatst. Keer terug naar onze hoofdpagina 
          om je spirituele reis met Lunssence voort te zetten.
        </p>
        
        <a href="/">
          <Button className="btn-hero text-lg px-8 py-4 animate-pulse-glow">
            <Home className="w-5 h-5 mr-2" />
            Terug naar Home
          </Button>
        </a>
      </div>
    </div>
  );
};

export default NotFound;
